import React from "react";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import './Product.css'


const Product = product => {
    console.log(product)
    const {productImage,price,productName,description,addToCart} = product
    const classes = useStyles();
    return <>
        <Grid item  xs={12} sm={6} md={3}>
            <Card className={classes.card}>
                <CardMedia
                    className={classes.cardMedia}
                    image={productImage}
                    title="Image title"
                />
                <CardContent className={classes.cardContent}>
                    <Typography gutterBottom variant="h5" component="h2">
                        {productName}
                    </Typography>
                    <Typography>
                        {description}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Typography>
                        {price}$
                    </Typography>
                    <Button onClick={addToCart.bind(this,product)} size="small" color="primary" >
                        Добавить в корзину
                    </Button>
                </CardActions>
            </Card>
        </Grid>
        </>
}

export default Product


const useStyles = makeStyles((theme) => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '75%', // 16:9

    },
    cardContent: {
        flexGrow: 1,
    },
}));